import {
  type ImportFileWizardState,
  WizardSteps,
} from "Pages/ImportWizard/model";
import { atom, selector } from "recoil";
import { importTypeState, tableState, uploaderState } from "./stateStep1";
import { previewTableState } from "./stateStep2";
import {
  copyPasteExtractedState,
  copyPasteIsDirtyTextAreaState,
  copyPasteProcessedState,
} from "./stateCopyPaste";

export const importFileWizardState = atom<ImportFileWizardState>({
  key: "ImportFile_ImportFIleWizardState",
  default: {
    FileName: "",
    FileExt: "",
    GroupIDs: [],
    Separator: "Comma",
    SendConfirmationMail: false,
    ConfirmationEmailId: 0,
    Pending: false,
    OptOut: false,
    ForceSubscription: false,
    ReplaceGroups: false,
    NotOverrideEmptyFields: false,
    IgnoreDoubleQuotes: false,
    IgnoreFirstRow: true,
    Delimitator: "DoubleQuotes",
    Username: "string",
    FieldMapping: [],
  },
});

export const importFileWizardStepState = atom<WizardSteps>({
  key: "ImportFile_importFileWizardStepState",
  default: WizardSteps.UploadFile,
});

export const importFileIsDirtyState = atom<boolean>({
  key: "ImportFile_importFileIsDirtyState",
  default: false,
});

export const step1EnabledState = selector<boolean>({
  key: "ImportFile_step1EnabledState",
  get: ({ get }) => {
    const importType = get(importTypeState);
    const { file } = get(uploaderState);
    const { fileSelected } = get(tableState);
    if (importType === "file" && file) {
      return true;
    }
    if (importType === "list" && fileSelected) {
      return true;
    }
    return false;
  },
});

export const step1CopyAndPasteEnable = selector<boolean>({
  key: "ImportFile_step1CopyAndPasteEnable",
  get: ({ get }) => {
    const testAreaIsDirty = get(copyPasteIsDirtyTextAreaState);
    const copyPasteProcessed = get(copyPasteProcessedState);
    const copyPasteExtracted = get(copyPasteExtractedState);

    if (!copyPasteProcessed) {
      return false;
    }
    if (copyPasteExtracted.length === 0) {
      return false;
    }
    if (testAreaIsDirty) {
      return false;
    }

    return true;
  },
});

export const step2EnabledState = selector<boolean>({
  key: "ImportFile_step2EnabledState",
  get: ({ get }) => {
    const { loading } = get(previewTableState);
    return !loading;
  },
});

export const step3EnabledState = selector<boolean>({
  key: "ImportFile_step3EnabledState",
  get: ({ get }) => {
    const { FieldMapping } = get(importFileWizardState);

    if (FieldMapping.length === 0) return false;

    if (FieldMapping.filter((f) => f.FieldID === undefined).length > 0)
      return false;
    if (
      FieldMapping.filter((f) => f.FieldID === 0).length === FieldMapping.length
    )
      return false;
    //email o tefefono obbligatorio
    if (
      !FieldMapping.some(
        (f) => f.FieldID === 111 || f.FieldID === 444 || f.FieldID === 333,
      )
    )
      return false;
    return true;
  },
});

export const step4EnabledState = selector<boolean>({
  key: "ImportFile_step4EnabledState",
  get: ({ get }) => {
    const { SendConfirmationMail, ConfirmationEmailId } = get(
      importFileWizardState,
    );

    if (SendConfirmationMail && ConfirmationEmailId <= 0) {
      return false;
    }

    return true;
  },
});
